// Import removed as IClubResourceData is not used in this file
import { PriceUnit } from "./addon-management.types";

export enum ClubBookingStatus {
  PENDING = 1,
  CONFIRMED = 2,
  CANCELLED = 3,
  COMPLETED = 4,
  PENDING_CONFIRMATION = 5,
}

export enum ResourceType {
  SAUNA_BOOKING = 1,
  KEYS = 2,
  ANNUAL_INSPECTIONS = 3,
  PORT_WATCH_SHIFTS = 4,
}

export interface ClubBookingUser {
  id: string;
  name: string | null;
  email: string;
}

export interface ClubBookingResource {
  id: string;
  name: string;
  resource_type: ResourceType;
  quantity: number | null;
  slot_length: string | null;
  price: number | null;
  price_unit: string | null;
  description?: string;
  availability?: boolean;
}

export interface ClubBookingItem {
  id: string;
  resource: {
    id: string;
    name: string;
    resource_type: ResourceType;
    quantity: number | null;
    slot_length: string | null;
    price: number | null;
    price_unit: string | null;
  };
  start_time: string;
  end_time: string;
  quantity: number | null;
  total_price: number;
  status: ClubBookingStatus;
  special_requests: string | null;
  cancellation_reason: string | null;
  created_at: string;
  inspector: {
    id: string;
    name: string | null;
    email: string;
  } | null;
}

export interface PaymentTransaction {
  id: string;
  amount: number;
  refunded_amount: number;
  currency: string;
  status: string;
  type: string;
  created_at: string;
  updated_at: string;
  payment_intent_id: string | null;
  stripe_refund_id: string | null;
}

export interface ClubBooking {
  id: string;
  user: {
    id: string;
    name: string | null;
    email: string;
  };
  club: {
    id: string;
    name: string;
    logo: string | null;
  };
  items: ClubBookingItem[];
  total_price: number;
  status: ClubBookingStatus;
  payment_transactions: PaymentTransaction[];
  created_at: string;
}

export interface IClubBookingData {
  id: string;
  user: {
    id: string;
    name: string | null;
    email: string;
  };
  resource: {
    id: string;
    name: string;
    resource_type: ResourceType;
    quantity: number | null;
    slot_length: string | null;
    price: number | null;
    price_unit: string | null;
  };
  club_id: string;
  start_date: string;
  end_date: string;
  start_time?: string;
  end_time?: string;
  total_price: number;
  payment_type: number;
  status: number;
  special_requests: string | null;
  cancellation_reason: string | null;
  quantity: number;
  created_at: string;
}

export interface PaginatedClubBookingResponse {
  data: ClubBooking[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface ClubBookingListQueryParams {
  page?: number;
  limit?: number;
  search?: string;
  status?: number;
  club_id?: string;
  resource_id?: string;
  start_date?: string;
  end_date?: string;
}

export interface AvailableClubResource {
  id: string;
  name: string;
  resource_type?: number;
  slot_length?: string;
  quantity?: number;
  is_available: boolean;
  price?: number;
  price_unit?: PriceUnit;
  allow_booking?: boolean;
}

export interface ClubBookingUpdateData {
  start_date?: string;
  end_date?: string;
  start_time?: string;
  end_time?: string;
  status?: number;
  cancellation_reason?: string;
  special_requests?: string;
  quantity?: number;
}
